<div class="wrapper">
  <app-layout-simple-header
    [hideInfoBar]="configLayout.removeInfoBar"
    [showAuth]="configLayout.headerLayout !== 'simple'"
  ></app-layout-simple-header>
  <router-outlet></router-outlet>
  <app-layout-simple-footer></app-layout-simple-footer>
</div>
